import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = ({ currentLanguage }) => {
  const trustElements = [
    {
      icon: 'Shield',
      title: currentLanguage === 'en' ? 'Licensed & Certified' : 'Ruhusa na Cheti',
      description: currentLanguage === 'en' ?'Fully licensed advocates registered with the Law Society of Kenya' :'Wanasheria wenye leseni kamili waliosajiliwa na Chama cha Sheria cha Kenya'
    },
    {
      icon: 'Clock',
      title: currentLanguage === 'en' ? '24-Hour Response' : 'Majibu ya Masaa 24',
      description: currentLanguage === 'en' ?'We respond to all inquiries within 24 hours during business days' :'Tunajibu maswali yote ndani ya masaa 24 wakati wa siku za kazi'
    },
    {
      icon: 'Lock',
      title: currentLanguage === 'en' ? 'Confidential & Secure' : 'Siri na Salama',
      description: currentLanguage === 'en' ?'All client communications are protected by attorney-client privilege' :'Mawasiliano yote ya wateja yanalindwa na haki ya mwanasheria-mteja'
    },
    {
      icon: 'Users',
      title: currentLanguage === 'en' ? 'Experienced Team' : 'Timu ya Uzoefu',
      description: currentLanguage === 'en' ?'Combined decades of legal experience across various practice areas' :'Miongo ya uzoefu wa pamoja wa kisheria katika maeneo mbalimbali ya utendaji'
    }
  ];

  const credentials = [
    {
      organization: currentLanguage === 'en' ? 'Law Society of Kenya' : 'Chama cha Sheria cha Kenya',
      status: currentLanguage === 'en' ? 'Active Members' : 'Wanachama Hai',
      year: '2015'
    },
    {
      organization: currentLanguage === 'en' ? 'Kenya Bar Association' : 'Chama cha Wanasheria wa Kenya',
      status: currentLanguage === 'en' ? 'Certified Advocates' : 'Wanasheria Wenye Cheti',
      year: '2015'
    },
    {
      organization: currentLanguage === 'en' ? 'International Bar Association' : 'Chama cha Wanasheria cha Kimataifa',
      status: currentLanguage === 'en' ? 'Associate Members' : 'Wanachama Washirika',
      year: '2018'
    }
  ];

  const clientCommitments = [
    {
      commitment: currentLanguage === 'en' ? 'Free Initial Consultation' : 'Mazungumzo ya Kwanza Bure',
      details: currentLanguage === 'en' ? '30 minutes at no cost' : 'Dakika 30 bila gharama'
    },
    {
      commitment: currentLanguage === 'en' ? 'Transparent Pricing' : 'Bei Wazi',
      details: currentLanguage === 'en' ? 'No hidden fees or charges' : 'Hakuna ada au gharama za siri'
    },
    {
      commitment: currentLanguage === 'en' ? 'Regular Updates' : 'Masasisho ya Mara kwa Mara',
      details: currentLanguage === 'en' ? 'Keep you informed throughout' : 'Kukufahamisha kila wakati'
    },
    {
      commitment: currentLanguage === 'en' ? 'Flexible Payment Plans' : 'Mipango ya Malipo ya Kubadilika',
      details: currentLanguage === 'en' ? 'Tailored to your situation' : 'Imepangwa kulingana na hali yako'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Trust Elements */}
      <div className="bg-white rounded-lg shadow-lg border border-border p-6 lg:p-8">
        <h3 className="text-xl font-semibold text-text-primary mb-6">
          {currentLanguage === 'en' ? 'Why Choose Peter & Partners?' : 'Kwa Nini Uchague Peter & Partners?'}
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {trustElements.map((element, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 bg-surface/20 rounded-lg flex items-center justify-center">
                <Icon name={element.icon} size={24} color="var(--color-primary)" />
              </div>
              
              <div className="flex-1">
                <h4 className="font-medium text-text-primary mb-1">{element.title}</h4>
                <p className="text-text-secondary text-sm">{element.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Professional Credentials */}
      <div className="bg-white rounded-lg shadow-lg border border-border p-6 lg:p-8">
        <h3 className="text-xl font-semibold text-text-primary mb-6">
          {currentLanguage === 'en' ? 'Professional Credentials' : 'Vyeti vya Kitaaluma'}
        </h3>
        
        <div className="space-y-4">
          {credentials.map((credential, index) => (
            <div key={index} className="flex items-center justify-between p-4 bg-surface/10 rounded-lg">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-primary/20 rounded-full flex items-center justify-center">
                  <Icon name="Award" size={16} color="var(--color-primary)" />
                </div>
                <div>
                  <h4 className="font-medium text-text-primary">{credential.organization}</h4>
                  <p className="text-text-secondary text-sm">{credential.status}</p>
                </div>
              </div>
              
              <div className="text-right">
                <p className="text-primary font-medium">{currentLanguage === 'en' ? 'Since' : 'Tangu'} {credential.year}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Client Commitments */}
      <div className="bg-white rounded-lg shadow-lg border border-border p-6 lg:p-8">
        <h3 className="text-xl font-semibold text-text-primary mb-6">
          {currentLanguage === 'en' ? 'Our Commitment to You' : 'Ahadi Yetu Kwako'}
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {clientCommitments.map((item, index) => (
            <div key={index} className="flex items-center space-x-3 p-3 rounded-lg hover:bg-surface/10 transition-colors duration-200">
              <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Check" size={14} color="#10B981" />
              </div>
              
              <div className="flex-1">
                <h4 className="font-medium text-text-primary text-sm">{item.commitment}</h4>
                <p className="text-text-secondary text-xs">{item.details}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Privacy Notice */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} color="#3B82F6" className="mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="font-medium text-blue-900 mb-2">
              {currentLanguage === 'en' ? 'Privacy & Confidentiality Notice' : 'Ilani ya Faragha na Usiri'}
            </h4>
            <p className="text-blue-800 text-sm leading-relaxed">
              {currentLanguage === 'en' ?'All information shared with Peter & Partners Advocates LLP is protected by attorney-client privilege and our strict confidentiality policies. We never share client information without explicit consent, except as required by law. Your privacy and trust are fundamental to our professional relationship.' :'Taarifa zote zinazoshirikiwa na Peter & Partners Advocates LLP zinalindwa na haki ya mwanasheria-mteja na sera zetu kali za usiri. Hatushiriki kamwe taarifa za wateja bila idhini ya wazi, isipokuwa inapohitajika na sheria. Faragha yako na imani ni misingi ya uhusiano wetu wa kitaaluma.'
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;